import {Component, OnInit} from '@angular/core';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {NzSelectModule} from 'ng-zorro-antd/select';
import {ReactiveFormsModule} from '@angular/forms';
import {isArray} from 'lodash-es';

@Component({
  selector: 'zorrly-select',
  standalone: true,
  imports: [
    CommonModule,
    FormlyModule,
    NzSelectModule,
    ReactiveFormsModule,
  ],
  template: `
    <nz-select *ngIf="optionsIsArray; else unable" nzShowSearch nzAllowClear [formControl]="$any(formControl)"
               [nzMode]="props.mode ? props.mode : 'default'">
      <nz-option *ngFor="let o of $any(props.options)" [nzValue]="o.value" [nzLabel]="o.label"
                 [nzDisabled]="o.disabled"></nz-option>
    </nz-select>
    <ng-template #unable>
      <div style="color:red">Unable to get options: {{ props.options | json }}</div>
    </ng-template>
  `,
})
export class ZorrlySelectComponent extends FieldType implements OnInit {

  constructor() {
    super();
  }

  async ngOnInit() {
  }

  get optionsIsArray(): boolean {
    return isArray(this.props.options);
  }

}
